import { useSelector } from 'react-redux';

import { TRootState } from '@/redux/rootReducer';
import { getAvailableService } from '@/redux/selectors/availableServices';
import { EProtections } from '@/services/types/core/protections';

import { useAddedRoamlyWeatherService } from './useAddedRoamlyWeatherService';
import { useAddedTripInsuranceService } from './useAddedTripInsuranceService';

export const useBillModuleProtectionData = () => {
  const availableTripInsuranceService = useSelector((state: TRootState) =>
    getAvailableService(state, EProtections.TRIP_INSURANCE),
  );
  const availableRoamlyWeatherInsuranceService = useSelector((state: TRootState) =>
    getAvailableService(state, EProtections.WEATHER_PROTECTION),
  );

  const addedTripInsuranceService = useAddedTripInsuranceService();
  const addedRoamlyWeatherInsuranceService = useAddedRoamlyWeatherService();

  const availableServiceIds = [
    availableTripInsuranceService?.id,
    addedTripInsuranceService?.id,
    availableRoamlyWeatherInsuranceService?.id,
    addedRoamlyWeatherInsuranceService?.id,
  ].filter(id => id != null);

  return {
    availableTripInsuranceService,
    addedTripInsuranceService,
    availableRoamlyWeatherInsuranceService,
    addedRoamlyWeatherInsuranceService,
    availableServiceIds,
  };
};
